import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  morePath?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  morePath,
  moreLabel = '查看更多',
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3">
        <span className="w-1 h-6 md:h-7 rounded-full bg-accent-500" />
        <div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            {title}
          </h2>
          {subtitle && (
            <p className="text-xs md:text-sm text-foreground-500 mt-1">{subtitle}</p>
          )}
        </div>
      </div>
      {morePath && (
        <Link
          to={morePath}
          className="flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      )}
    </div>
  );
}